import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, IconButton, Tooltip } from "@mui/material";
import MemberCardAction from ".";
import { useAppSelector } from "../../hooks";
import { AuthenticateState } from "../../types/types";
import { PiCoinsFill } from "react-icons/pi";

import "./index.css";
import { createClickEngagementRecorder } from "../../utils/api";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";

const MemberCardActionButton: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { authenticateStatus } = useAppSelector((state) => state.auth);
  const { roomDomain, roomUrl } = useWhiteboardRoom();
  const iconRef = useRef(null);
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const handleMemberCardBtnClick = () => {
    setIsOpen((prev) => !prev);
    clickRecorder("memberCard");
  };

  return (
    <>
      <Tooltip
        title={t("Menu_Engagement_Rewards")}
        placement="bottom"
        arrow
        disableInteractive
      >
        <IconButton
          aria-label="wallet"
          onClick={handleMemberCardBtnClick}
          ref={iconRef}
          sx={{ padding: "5px", '&:hover': {backgroundColor: 'transparent' }}}
        >
          <Badge
            color="warning"
            variant="dot"
            invisible={authenticateStatus !== AuthenticateState.WALLET}
          >
            <PiCoinsFill
              color={isOpen ? "#1f8feb" : "#ffa726"}
              style={{ fontSize: "20px" }}
            />
          </Badge>
        </IconButton>
      </Tooltip>
      <MemberCardAction isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default MemberCardActionButton;
